import { mapGetters, mapActions } from "vuex";
import TableauDestinataire from '../TableauDestinataires/TableauDestinataires.vue'
import DropDownDestinataires from "../DropDownDestinataires/DropDownDestinataires.vue";
import SearchDestinataire from '../SearchDestinataire/searchDestinataire';
import DisambiguationModal from '../DisambiguationModal/DisambiguationModal.vue';
import {
    Drag
} from "vue-easy-dnd";

export default {
    name: "DetailCommandeLetrecoElec",
    components: {
        TableauDestinataire, DropDownDestinataires, DisambiguationModal,Drag
    },
    props: ["commandeId", "expanded"],
    computed: {
        ...mapGetters(["auth"]),
        commandeDocumentFields: function() {
            let fields = [
                { key: 'libelle', sortable: true }
            ];
            if (!this.commande.ref_suivi_poste) {
                fields.push({ key: 'action' });
            }
            return fields;
        },
        isAdmin() {
            if(this.auth && this.auth.user && this.auth.user.roles && 
                this.auth.user.roles.find((role) => role.name === "admin")) {
                return true
            }
            return false
        },
        composantes() {
            return this.commande.categorie.composantes.filter((comp) => {
                return comp.sous_categorie_id === this.commande.sous_categorie_id || !this.commande.sous_categorie_id
            })
        },
        ambiguousFile() {
            if(this.commande && this.commande.commande_documents && this.commande.commande_documents.length > 0) {
                return this.commande.commande_documents.find(doc => doc.destinataire_id === -1)
            }
            return null
        }
    },
    data() {
        return {
            dragging: false,
            envoiEnCours: false,
            downloadAck: false,
            timeoutCommande: false,
            rafraichissementEnCours: false,
            interval: 0,
            commande: {},
            commandeLoading: true,
        };
    },
    methods: {
        ...mapActions([
            'uploadFiles', 'updateCommande', 'sendCommandeLetreco', 'deleteDocument', 'getDepositProof', 
            'getAcquittement', 'checkCommande', 'exportDestinataires', 'supprimerCommande', 'loadCommande'
        ]),
        dropFileOnDestinataire(event) {
            const file = this.commande.commande_documents.find(c => c.id === event.data.id)
            this.selectDestinataire({file, dest:event.destinataire})
        },
        selectDestinataire({file, dest}) {
            if(dest.id) {
                file.destinataire_id = dest.id
            } else {
                file.destinataire_id = null
            }
            this.saveAfterWait()
        },
        confirmerSupprimerCommande(commande) {
            this.rafraichissementEnCours = true
            this.supprimerCommande({commande, callerComponent: this}).then((accepted) => {
                if(accepted) {
                    this.$emit("commandeSupprimee", this.commande);
                }
                this.rafraichissementEnCours = false
            })
        },
        rafraichir(commande) {
            this.rafraichissementEnCours = true;
            this.checkCommande(commande).then(() => {
                this.$emit("commandeMiseAJour", this.commande);
                this.rafraichissementEnCours = false;
            });
        },
        saveAfterWait() {
            if(this.timeoutCommande) {
                clearTimeout(this.timeoutCommande);
            }
            this.timeoutCommande = setTimeout(() => {  
                this.updateCommande(this.commande).then(response => {
                    this.$toasted.show("Commande mise à jour.", {
                        icon: {
                            name: 'check-circle',
                        },
                        theme: "outline",
                        position: "bottom-center",
                        duration : 2000
                    });
                });
            }, 2000);
        },
        fichiers(composanteId) {
            return this.commande.commande_fichiers.filter(fic => fic.composante_id === composanteId)
        },
        addFileDnD(event) {
            if (event.dataTransfer.files) {
                this.sendFiles(event.dataTransfer.files)
            };
        },
        addFileBtn(event) {
            this.sendFiles(event.target.files)
            event.target.value = ''
        },
        sendFiles(files) {
            this.dragging = false;            
            let formData = new FormData();
            [...files].forEach((file,index) => {
                formData.append('file'+index, file);
            });
            this.uploadFiles(formData).then(response => {
                this.commande.documents = response.data;
                this.updateCommande(this.commande).then(response => {                    
                    this.commande.commande_destinataires = response.data.commande_destinataires
                    this.commande.commande_documents = response.data.commande_documents
                    this.commande.documents = []
                    this.$toasted.show("Commande mise à jour.", {
                        icon: {
                            name: 'check-circle',
                        },
                        theme: "outline",
                        position: "bottom-center",
                        duration : 2000
                    });
                });
            })
            this.fileSelect = 0;
        },
        telechargerAcquittement(reference, destinataire) {
            this.downloadAck = true;
            this.getAcquittement({reference:reference, email:destinataire.mail}).then(() => this.downloadAck = false);
        },
        telechargerPreuveDeDepot(reference) {
            this.envoiEnCours = true;
            this.getDepositProof(reference).then(() => this.envoiEnCours = false);
        },
        envoyerDocument() {
            this.envoiEnCours = true;
            this.sendCommandeLetreco(this.commande.id).then(response => {
                this.commande.ref_suivi_poste = response.data.ref_suivi_poste;
                this.envoiEnCours = false;
                this.$toasted.show("Commande expédiée", {
                    icon: {
                        name: 'check-circle',
                    },
                    theme: "outline",
                    position: "bottom-center",
                    duration : 2000
                });
                this.$emit("commandeExpediee", this.commande);
            }).catch((e) => {
                this.envoiEnCours = false;
            });
        },
        supprimerDocument(documentId){
            this.deleteDocument(documentId).then(response => {
                let index = this.commande.commande_documents.findIndex((o) => {
                    return o.id === documentId;
                })
               if (index !== -1) this.commande.commande_documents.splice(index, 1);
               this.$toasted.show("Document supprimé", {
                    icon: {
                        name: 'trash',
                    },
                    theme: "outline",
                    position: "bottom-center",
                    duration : 2000
                });
            });
        },
        avancementToIcon(code) {
            if(code <= 1) {
                return '<i class="far fa-clock"></i>';
            } else if(code === 2) {
                return '<i class="far fa-paper-plane"></i>';
            } else if(code === 3) {
                return '<i class="fas fa-flag-checkered"></i>';
            } else if(code === 4) {
                return '<i class="fas fa-exclamation-circle"></i>';
            }
            return '<i class="fas fa-bug"></i>'; 
        },
        avancementToText(code) {
            if(code <= 1) {
                return 'Nouveau';
            } else if(code === 2) {
                return 'Expédié, en attente d\'acquittement';
            } else if(code === 3) {
                return 'Acquitté';
            } else if(code === 4) {
                return 'Rejeté';
            }
            return 'En erreur, code:'+code; 
        },
    },
    filters: {

    },
    watch: {
        'commande.commentaire': function(oldComment, newComment) {
            if(oldComment != newComment && newComment != null) {
                this.saveAfterWait();
            }
        },
        'commande.sujet': function(oldComment, newComment) {
            if(oldComment != newComment && newComment != null) {
                this.saveAfterWait();
            }
        },
        'commande.commande_destinataires': function(data) {
            this.commande.commande_documents.forEach(doc => { 
                if(doc.destinataire_id === null) {
                    const matchedDest = SearchDestinataire.searchDestinataire(doc.libelle, data)
                    if(matchedDest.length > 1) {
                        doc.destinataire = matchedDest
                        doc.destinataire_id = -1
                    } else if(matchedDest.length === 1) {
                        doc.destinataire_id = matchedDest[0].id
                    } else {
                        doc.destinataire_id = null
                    }
                }
            })
        },
        'commande.commande_documents': function(data) {
            data.forEach(doc => { 
                if(doc.destinataire_id === null) {
                    const matchedDest = SearchDestinataire.searchDestinataire(doc.libelle, this.commande.commande_destinataires)
                    if(matchedDest.length > 1) {
                        doc.destinataire = matchedDest
                        doc.destinataire_id = -1
                    } else if(matchedDest.length === 1) {
                        doc.destinataire_id = matchedDest[0].id
                    } else {
                        doc.destinataire_id = null
                    }
                }
            })
        },
    },
    mounted() {
        this.commandeLoading = true
        this.loadCommande(this.commandeId).then((commande) => {
            this.commande = commande
            this.commandeLoading = false
        })
    },

}
